export const TOKEN_PREFIX = "";
export const QUANTITY_DATA = "20"; //Debe ser 20
export const QUANTITY_DATA_CATEGORY = "15";
export const QUANTITY_DATA_DOCUMENT = "30"; //debe ser 30
export const SIZE_IMAGE = "1024";
export const SIZE_MAX_BULKLOAD_CLIENT = "300"; //In Kb
export const SIZE_FILE_BULKLOAD = 50000;
export const EXPIRATION_DAY_BULKLOAD = 5;
export const QUANTITY_DATA_MULTIMEDIA = 30;
export const QUANTITY_DATA_CUSTOMER = 30;
export const TIME_CREATE_REGISTER = 6000; // Tiempo en cerra el modal cuando se realiza un registro --segundos
export const TIME_UPDATE_REGISTER = 4000; // Tiempo en cerra el modal cuando se realiza un registro --segundos
export const MESSAGE_DELETE_CONFIRM = "Eliminar";
export const MESSAGE_NEXT_CONFIRM = "Confirmar";

export const API_ENDPOINT = "https://core.colfactura.com";
export const API_ENDPOINT_ARTICLE = "https://core.colfactura.com/item";
export const API_ENDPOINT_CATALOG = "https://core.colfactura.com";
export const API_ENDPOINT_CONFIGURATION = "https://core.colfactura.com/conf";
export const API_ENDPOINT_ENTERPRISE = "https://core.colfactura.com/enterprise";
export const API_ENDPOINT_CUSTOMERS = "https://core.colfactura.com/customer";
export const API_ENDPOINT_DOCUMENT = "https://core.colfactura.com/document";
export const API_ENDPOINT_DASHBOARD = "https://core.colfactura.com/dashboard";
export const API_ENDPOINT_CONSULT_DOCUMENT = "https://prod.colfactura.com/consult";
export const API_ENDPOINT_INTEGRATION = "https://core.colfactura.com/document";
export const API_ENDPOINT_DOCUMENT_RECEPTION = "https://prod.colfactura.com";
export const URL_SECURITY = "https://security.colfactura.com/";
export const API_ENDPOINT_DISCHARGE = "https://corelicence.gse.com.co";
export const API_ENDPOINT_IBUHOO = "https://coresecurity.gse.com.co";
export const URL_IMAGES = "https://core.colfactura.com";
export const API_IBUHOO_IMAGEMANAGER = "https://core.colfactura.com";
export const CHATBOT_WOLKVOX = "https://chat01.ipdialbox.com/chat/?prodId=Z3NlLjM0Mg==";
export const API_ENDPOINT_SIGNALR = "https://core.colfactura.com";

export const URL_LICENCE = "https://store.colfactura.com";
export const CLAIM_BRANCH_OFFICES = "COLFACTURA_SUCURSALES";
export const CLAIM_USERS = "COLFACTURA_USUARIOS";
export const CLAIM_DOCUMENTS = "COLFACTURA_PROCESAMIENTOFACTURAS";

export const DEFAULTRESPONSE = {
  noResponseFromApi: {
    statusCode: "500",
    statusMessage: "No hay respuesta por parte del servidor.",
    result: "",
  },
  SuccessResponse: {
    statusCode: "200",
    statusMessage: "Transacción exitosa",
    result: "",
  },
};

export function defaultHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
    },
  };
}

export const ROL_CFCOLAB = "CFCOLAB";

// Maximum size of images in bytes
export const imageSize = 2097152;

// Size of the image cutter canvas
export const imageCutterSize = {
  width: 450,
  height: 450,
};

export const TIME_REFRESH_TOKEN = 20;

//Rango dias permitidos para fecha emsión documento
export const MIN_DAYS_DATE_DOCUMENT = 10; //Maximo 10 DIAN
export const MAX_DAYS_DATE_DOCUMENT = 10; //Maximo 10 DIAN

export const DIGITS_BEFORE_DECIMAL = 12;
export const DIGITS_AFTER_DECIMAL = 4;
export const DIGITS_AFTER_DECIMAL_DOC = 2;
export const DIGITS_AFTER_DECIMAL_EQUIVALENT_DOC = 2;

export const READING_MODE = false;
